import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  updateButtonContainer: {
    marginLeft: 'auto',
  },
  dateField: {
    padding: theme.spacing(2.5, 0, 2.5, 0),
  },
  customWrapper: {
    width: '100%',
    display: 'flex',
    gap: theme.spacing(1),
  },
  extendOfferExpiry: {
    fontSize: '14px !important',
    height: theme.spacing(2.5),
    minHeight: `${theme.spacing(2.5)} !important`,
  },
  disabledEdit: {
    opacity: '39%',
  },
  radioButton: {
    marginTop: theme.spacing(2),
    '& .MuiFormGroup-root': {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: theme.spacing(0.5),

      '& > *': {
        flexBasis: '30%',
        flexGrow: 1,
      },

      '& > *:nth-child(4)': {
        flexBasis: '100%',
        flexGrow: 0,
      },
    },
  },
}))
